/**
 * 类别&费用信息
 */
import React, { memo } from 'react';
import { connect } from 'react-redux';
import { RightOutlined } from '@ant-design/icons';
import intl from 'react-intl-universal';
import IconFont from '@/components/IconFont';
import { uuid, renderContent } from '@/utils';
import { parseFen2Currency } from '@/utils/number';
import { createStateSelector } from '@/redux/actions/reservation/helper';
import { ReducerState, storeName } from '@/redux/reducers/bill/invoice';
import useInvoicedBillDetailDrawer, { typeEnum } from '../InvoicedBillDetailDrawer';
import { categoryTypeEnum, categoryTypeMap, categoryTypeMapForIcon } from '../../constant';
import styles from './index.module.scss';

const stateSelector = (state: ReducerState) => {
  const { categories, orderList } = state;
  return { categories, orderList };
};
const mapStateToProps = createStateSelector<ReducerState>(storeName, stateSelector);
const mapDispatchToProps = {
  // callItemChange: handleRecordItemChange,
};

type MapStateProps = ReturnType<typeof stateSelector>;
type MapDispatchProps = typeof mapDispatchToProps;

interface IProps {
  // orders: Array<{ orderNo: string; orderType: string }>;
}

const Index: React.FC<IProps & MapStateProps & MapDispatchProps> = ($$) => {
  const invoicedBillDetailPortal = useInvoicedBillDetailDrawer();

  const detailHandle = (type: typeEnum) => {
    const orders = $$.orderList.map((item) => {
      return {
        orderNo: item.orderNo,
        orderType: item.orderType,
      };
    });
    invoicedBillDetailPortal.showDrawer({ type, orders });
  };

  const renderPrice = (price: number) => {
    return parseFen2Currency(price);
  };

  const renderDetailBtn = (category: categoryTypeEnum, item: any) => {
    if (category === categoryTypeEnum.memberCard || category === categoryTypeEnum.valueAdd)
      return null;
    // 已选订单中没有房费/商品的话 按钮置灰
    if (item.availableAmt <= 0)
      return (
        <div className={`${styles.topRight} ${styles.disabledColor}`}>
          {intl.get('bill_invoice_modal_detail')}{' '}
          <RightOutlined style={{ fontSize: 14, color: '#999999' }} />
        </div>
      );
    return (
      <div className={styles.topRight} onClick={() => detailHandle(item.category)}>
        {intl.get('bill_invoice_modal_detail')}{' '}
        <RightOutlined style={{ fontSize: 14, color: '#3F79FF' }} />
      </div>
    );
  };

  const renderTotalPrice = () => {
    let total = null;
    ($$.categories || []).forEach((item) => {
      total += Number(
        item.availableAmt - item.invoicedAmt < 0 ? 0 : item.availableAmt - item.invoicedAmt,
      );
    });
    return renderContent(parseFen2Currency(total));
  };

  return (
    <>
      <div className={styles.invoiceAmount}>
        {($$.categories || []).map((item) => {
          return (
            <div key={uuid()} className={styles.item}>
              <div className={styles.top}>
                <div className={styles.topLeft}>
                  <div className={styles.iconArea}>
                    <IconFont
                      type={categoryTypeMapForIcon[item.category]}
                      className={styles.icon}
                    />
                  </div>
                  <div className={styles.fee}>
                    <div className={styles.title}>{categoryTypeMap[item.category]}</div>
                    <div className={styles.feeValue}>{renderPrice(item.availableAmt)}</div>
                  </div>
                </div>
                {renderDetailBtn(item.category, item)}
              </div>
              <div className={styles.bottom}>
                <div>
                  <span className={styles.bottomTitle}>
                    {intl.get('bill_invoice_modal_invoiced_amt_colon')}
                  </span>
                  <span>{renderPrice(item.invoicedAmt)}</span>
                </div>
                <div>
                  <span className={styles.bottomTitle}>
                    {intl.get('bill_invoice_modal_not_invoiced_amt_colon')}
                  </span>
                  <span>
                    {renderPrice(
                      item.availableAmt - item.invoicedAmt < 0
                        ? 0
                        : item.availableAmt - item.invoicedAmt,
                    )}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className={styles.totalInvoiceAmount}>
        {intl.get('bill_invoice_modal_total_amt_colon')}
        <span>{renderTotalPrice()}</span>
      </div>
    </>
  );
};

export default connect<MapStateProps, MapDispatchProps, IProps>(
  mapStateToProps,
  mapDispatchToProps,
)(memo(Index));
